const header = document.querySelector('.section-header');
const isStickyHeader = header.querySelector('.header').dataset.stickyHeader;
if (isStickyHeader == 'false') return;

header.classList.add('sticky-header');
let lastScrollY = window.scrollY;
let ticking = false;
const scrollThreshold = 0;

function isMobile() {
  return window.innerWidth <= 768;
}

function onScroll() {
  if (!isMobile()) {
    header.classList.remove('transform', '-translate-y-full');
    return;
  }

  const currentScrollY = window.scrollY;

  if (Math.abs(currentScrollY - lastScrollY) < scrollThreshold) {
    ticking = false;
    return;
  }

  if (currentScrollY > lastScrollY && currentScrollY > 100) {
    header.classList.add('transform', '-translate-y-full');
  } else {
    header.classList.remove('transform', '-translate-y-full');
  }

  lastScrollY = currentScrollY;
  ticking = false;
}

window.addEventListener('scroll', function () {
  if (!ticking) {
    window.requestAnimationFrame(onScroll);
    ticking = true;
  }
});

window.addEventListener('resize', onScroll);
